import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { SaveType } from '@/editor/lib/declarations/SaveType';
import { useFormSubmitHandler } from '@/views/BaseSettingsViewForm';

export const SaveFormButton: FC = () => {
  const { t: tCommon } = useTranslation('common');
  const {
    formState: { isValid, isSubmitting, isValidating, isDirty },
  } = useFormContext();

  const submitForm = useFormSubmitHandler();

  // console.log('SaveFormButton render', { isValid, isSubmitting, isValidating, isDirty });

  return (
    <Button
      variant='contained'
      color='secondary'
      disabled={!isDirty || isSubmitting || isValidating}
      onClick={submitForm}>
      {tCommon(`SaveType.${SaveType.SAVE}`)}
    </Button>
  );
};

export default SaveFormButton;
